const CSS = 'hr.divider{border-block-start:1px solid rgb(var(--colour-neutral-3,223,223,223))}';
import { createFeatureMapper } from "./utils/feature-configurator.js";
const features = {
  base: "divider"
};
var Divider_default = { CSS, classnames: createFeatureMapper(features) };
export {
  Divider_default as default
};
